<template>
   <div class="w-full p-0">
        <div v-if="isLoading" class="center ml-0 px-2 py-2 xl:py-4 lg:py-4">
            <div class="w-full surface-0 border-1 border-100 px-3 py-4 border-round-2xl">Загружаем статью...</div>
        </div>

        <div v-else-if="article" class="center ml-0 px-2 py-2 xl:py-4 lg:py-4">
            <div class="grid">

                <aside class="hidden xl:flex lg:flex col-12 xl:col-2 lg:col-2 md:col-12 sm:col-12">
                    <div class="w-full flex flex-column gap-2">
                        <router-link
                            to="/"
                            class="flex text-primary no-underline"
                        >
                            <div class="w-full flex flex-column px-3 py-4 border-round-2xl">
                                Назад в ленту
                            </div>
                        </router-link>
                        <div class="w-full flex flex-column gap-2 surface-0 border-1 border-100 px-3 py-4 border-round-2xl">
                            <span class="text-lg font-medium">Материал</span>
                            <span class="text-sm text-500">Опубликовано {{ formatDate(article.publishedAt) }}</span>
                        </div>
                    </div>
                </aside>

                <article class="col-12 xl:col-10 lg:col-7 md:col-12 sm:col-12">
                    <div class="w-full surface-0 border-1 border-100 py-4 border-round-3xl
                        px-3 xl:px-6 lg:px-5 md:px-4 sm:px-3">
                        <!-- <div class="article-shell__breadcrumbs">
                            <span class="text-500">Блог</span>
                            <span class="article-shell__separator">/</span>
                            <span>{{ article.title }}</span>
                        </div> -->

                        <header class="article-header">
                            <div class="article-header__meta">
                                <span class="article-header__pill">Инструкция</span>
                                <span>{{ getReadingTime(article) }} мин чтения</span>
                                <span v-if="article.country">#{{ article.country }}</span>
                            </div>
                            <h1 class="article-header__title">{{ article.title }}</h1>
                        </header>

                        <figure v-if="article.cover?.url" class="w-full m-0 mb-5">
                            <img :src="article.cover.url" :alt="article.cover.alt || article.title" class="w-full border-round-2xl" />
                        </figure>

                        <NotionBlockRenderer :blocks="article.blocks" />

                        <section v-if="relatedArticles.length" class="mt-6 pt-4 border-top-1 border-200">
                            <h2 class="text-2xl font-medium mt-0 mb-3">Похожие статьи</h2>
                            <div class="flex flex-column gap-3">
                                <router-link
                                    v-for="relatedArticle in relatedArticles"
                                    :key="relatedArticle.slug"
                                    :to="getArticleRoute(relatedArticle)"
                                    class="surface-0 border-1 border-100 border-round-xl px-3 py-3 no-underline text-900"
                                >
                                    <div class="text-sm text-500 mb-1">{{ formatDate(relatedArticle.publishedAt) }}</div>
                                    <div class="text-lg font-medium">{{ relatedArticle.title }}</div>
                                    <p v-if="relatedArticle.excerpt" class="text-600 mb-0 mt-2">{{ relatedArticle.excerpt }}</p>
                                </router-link>
                            </div>
                        </section>
                    </div>
                </article>

                <!-- <aside class="col-12 xl:col-3 lg:col-3 md:col-12 sm:col-12 flex flex-column gap-3">
                    <div class="w-full surface-0 border-1 border-100 px-3 py-4 border-round-2xl">
                        <span class="text-lg font-medium">В материале</span>
           
                    </div>
                </aside> -->
            </div>
        </div>

        <div v-else class="article-empty">
            <h1 class="article-empty__title">Статья не найдена</h1>
            <p class="article-empty__text">{{ errorMessage || 'Проверьте ссылку или вернитесь в список статей.' }}</p>
                <router-link to="/" class="article-empty__link">Перейти в блог</router-link>
        </div>
    </div>
</template>

<script>
import NotionBlockRenderer from '@/components/blog/NotionBlockRenderer.vue'
import Connect from '@/assets/js/Connect'
import { buildArticleRoute, getArticleRouteCode } from '@/assets/js/blog/articleRoute'

const connect = new Connect()

export default {
    name: 'BlogArticlePage',
    components: {
        NotionBlockRenderer,
    },
    data() {
        return {
            article: null,
            relatedArticles: [],
            isLoading: false,
            errorMessage: '',
        }
    },
    computed: {
        articleCode() {
            return getArticleRouteCode(this.$route.params)
        },
    },
    watch: {
        articleCode: {
            immediate: true,
            async handler() {
                await this.fetchArticle()
            },
        },
    },
    methods: {
        // Загружаем детальную статью из backend и затем блок рекомендаций.
        async fetchArticle() {
            this.isLoading = true
            this.errorMessage = ''
            this.relatedArticles = []

            const response = await connect.GetArticleByCode(this.articleCode)

            if (response?.result) {
                this.article = response.data || null
                this.updatePageTitle()
                await this.fetchRelatedArticles()
            } else {
                this.article = null
                this.errorMessage = response?.message || 'Не удалось загрузить статью.'
                this.updatePageTitle()
            }

            this.isLoading = false
        },
        async fetchRelatedArticles() {
            const response = await connect.GetRelatedArticlesByCode(this.articleCode, 3)

            if (response?.result) {
                this.relatedArticles = response.data || []
            } else {
                this.relatedArticles = []
            }
        },
        formatDate(value) {
            if (!value) {
                return 'не указано'
            }

            return new Intl.DateTimeFormat('ru-RU', {
                day: '2-digit',
                month: 'long',
                year: 'numeric',
            }).format(new Date(value))
        },
        updatePageTitle() {
            document.title = this.article ? `${this.article.seo?.title || this.article.title} | Aasia` : 'Статья не найдена | Aasia'
        },
        getReadingTime(article) {
            return article?.readingTime || 1
        },
        getArticleRoute(article) {
            return buildArticleRoute(article)
        },
    },
}
</script>

<style scoped>
.article-page {
    min-height: 100%;
    padding: 1.5rem 0 3rem;
    background: #f3f4f6;
}

.article-layout,
.article-empty {
    width: min(1320px, calc(100% - 2rem));
    margin: 0 auto;
}

.article-layout {
    display: grid;
    grid-template-columns: 180px minmax(0, 760px) 240px;
    gap: 1.5rem;
    align-items: start;
}

.article-rail {
    position: sticky;
    top: 88px;
}

.article-rail__back,
.article-shell__crumb {
    color: #16a34a;
    text-decoration: none;
    font-weight: 600;
}

.article-rail__meta,
.article-rail__card {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.article-rail__label {
    color: #6b7280;
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.article-rail__value {
    color: #111827;
    font-size: 1rem;
    font-weight: 700;
}

.article-rail__small {
    color: #6b7280;
    font-size: 0.9rem;
    line-height: 1.5;
}

.article-shell__breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-bottom: 1.1rem;
    color: #6b7280;
    font-size: 0.92rem;
}

.article-shell__separator {
    color: #9ca3af;
}

.article-card,
.article-empty {
    padding: 1.5rem;
    border: 1px solid #e5e7eb;
    border-radius: 18px;
    background: #ffffff;
}

.article-header {
    margin-bottom: 2rem;
}

.article-header__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
    color: #6b7280;
    font-size: 0.9rem;
}

.article-header__pill {
    padding: 0.35rem 0.7rem;
    border-radius: 999px;
    background: #ecfdf5;
    color: #15803d;
    font-size: 0.8rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.article-header__title,
.article-empty__title {
    margin: 1rem 0 0;
    color: #111827;
    font-size: clamp(2.25rem, 4vw, 3.75rem);
    line-height: 0.98;
}

.article-header__lead {
    max-width: 42rem;
    margin: 1rem 0 0;
    color: #4b5563;
    font-size: 1.06rem;
    line-height: 1.7;
}

.article-header__source,
.article-empty__link {
    display: inline-flex;
    margin-top: 1rem;
    color: #111827;
    text-decoration: none;
    font-weight: 700;
}

.article-empty {
    text-align: center;
}

.article-empty__text {
    margin: 1rem 0 0;
    color: #4b5563;
    line-height: 1.7;
}

@media screen and (max-width: 1100px) {
    .article-layout {
        grid-template-columns: minmax(0, 1fr) 230px;
    }

    .article-rail--left {
        display: none;
    }
}

@media screen and (max-width: 860px) {
    .article-layout {
        grid-template-columns: 1fr;
    }

    .article-rail {
        position: static;
    }

    .article-rail--right {
        order: 3;
    }
}

@media screen and (max-width: 576px) {
    .article-page {
        padding-top: 1rem;
    }

    .article-layout,
    .article-empty {
        width: calc(100% - 1rem);
    }

    .article-card,
    .article-empty {
        padding: 1.1rem;
        border-radius: 14px;
    }
}
</style>
